import React from 'react'
import { Outlet } from 'react-router-dom'

const Customer = () => {
  return (
    <>
      <Outlet />
    </>
  )
}

export default Customer
